import { istDateInput } from '../payments/paymentDates';
import { invoiceTemplateVersions, type InvoiceTemplate } from './invoiceTemplate.config';
export function pickTemplateVersion(
  invoiceDate: string,
  versions: readonly InvoiceTemplate[] = invoiceTemplateVersions,
): InvoiceTemplate {
  const date = /^\d{4}-\d{2}-\d{2}$/.test(invoiceDate)
    ? invoiceDate
    : istDateInput(new Date(invoiceDate));
  const ordered = [...versions].sort((a, b) => b.validFrom.localeCompare(a.validFrom));
  const version = ordered.find((v) => v.validFrom <= date) ?? ordered[ordered.length - 1];
  if (!version) throw new Error('No DNM invoice template is configured.');
  return version;
}
